import { create } from 'zustand'
import { shallow } from 'zustand/shallow'
import Icon from 'Common/UI/Component/Icon'
import Input from 'Common/UI/Component/Input'
import { transformResponseError, transformResponseToSingle } from 'Common/Utility/formatter'
import Button from 'Common/UI/Component/Button'
import { BaseDialog } from 'Common/UI/Block/Dialog'
import { useAssignAccountWhistleblowOperator } from 'Core/Authentication/API/AccountAPI'
import { Dialog } from '@headlessui/react'
import Radio from 'Common/UI/Component/Radio'
import AlertView from 'Common/UI/Block/AlertView'
import classNames from 'classnames'

const initialStore = {
    show: false,
    ID: '',
    password: '',
    selectedType: null,
}

export const useAssignAccountWhistleblowOperatorDialogStore = create((set) => ({
    ...initialStore,

    setShow: (value) => set(() => ({ show: value })),
    confirm: ({ ID }) => {
        let update = { show: true, ID }
        return set(() => update)
    },

    setPassword: (value) => set(() => ({ password: value })),
    setSelectedType: (value) => set(() => ({ selectedType: value })),
    reset: () => set(() => initialStore)
}))

export function AssignAccountWhistleblowOperatorDialog({ onConfirm = () => null }) {
    const show = useAssignAccountWhistleblowOperatorDialogStore(state => state.show)
    const setShow = useAssignAccountWhistleblowOperatorDialogStore(state => state.setShow)

    const { ID, password, selectedType } = useAssignAccountWhistleblowOperatorDialogStore(state => ({ ID: state.ID, password: state.password, selectedType: state.selectedType }), shallow)
    const { setPassword, setSelectedType } = useAssignAccountWhistleblowOperatorDialogStore(state => ({ setPassword: state.setPassword, setSelectedType: state.setSelectedType }))
    const reset = useAssignAccountWhistleblowOperatorDialogStore(state => state.reset)

    const assignAccountWhistleblowOperator = useAssignAccountWhistleblowOperator({
        onSuccess: (response) => {
            onConfirm(transformResponseToSingle(response))
            reset()
        }
    })
    const error = transformResponseError(assignAccountWhistleblowOperator.error)

    const submit = (e) => {
        e.preventDefault()
        assignAccountWhistleblowOperator.mutate({ ID, password, type: selectedType?.title })
    }

    return (
        <BaseDialog show={show} onClose={() => setShow(false)} >
            {({ cancelButtonRef }) => (
                <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                    <form onSubmit={submit}>
                        <div>
                            <div className={`mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-lime-100`}>
                                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                                    <Icon.IconPhospor.UserPlus className="h-6 w-6 text-green-600" aria-hidden="true" />
                                </div>
                            </div>

                            <div className="mt-3 text-center sm:mt-5">
                                <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                                    Tambah Akses/Akun
                                </Dialog.Title>
                                <div className="mt-2">
                                    <p className="text-sm text-gray-500">
                                        Silahkan lengkapi isian dibawah ini
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='mt-7 grid grid-cols-1 gap-8 md:gap-3'>
                            <span className="p-float-label">
                                <Input.InputSecure
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className={classNames('w-full', error['password'] ? 'p-invalid' : null)}
                                />
                                <label htmlFor="morningActivity">Kata Sandi</label>
                            </span>
                            <AlertView.ErrorInput errors={error['password']} />

                            <div>
                                <Radio.Card
                                    value={selectedType}
                                    onChange={setSelectedType}
                                    gridWrapperClassName="grid-cols-1 sm:grid-cols-2"
                                    error={error['type']}
                                    optionKeySelector={(option) => option.title}
                                    options={[
                                        { title: 'Administrator', description: 'Dapat mengakses seluruh fungsi yang ada modul WBS', note: null },
                                        { title: 'Complaint Officer', description: 'Petugas yang memproses laporan', note: null },
                                    ]}
                                />
                            </div>
                            <AlertView.ErrorInput errors={error['type']} />
                        </div>

                        <div className="flex justify-end gap-1.5 mt-4">
                            <Button.LoadableButton
                                variant='secondary'
                                type="button"
                                onClick={() => setShow(false)}
                                ref={cancelButtonRef}
                            >
                                Batal
                            </Button.LoadableButton>
                            <Button.LoadableButton
                                type='submit'
                                loading={assignAccountWhistleblowOperator.isLoading}
                                loadingText='Memproses..'
                            >
                                Simpan
                            </Button.LoadableButton>
                        </div>
                    </form>
                </div>
            )}
        </BaseDialog>
    )
}